export enum PasswordRules {
  validLength = 'validLength',
  includeUppercase = 'includeUppercase',
  includeLowercase = 'includeLowercase',
}
